import { Link } from "react-router-dom";

/**
 * Reusable inline CTA for blog articles. Marble background, thin gold border,
 * Playfair heading. Placed mid-article (after the last <h3> section) and at
 * the end of every post — future articles get both slots for free.
 */
export default function BlogCTA({ testid = "blog-cta" }) {
  return (
    <aside
      className="mt-10 mb-10 rounded-lg border px-6 py-8 text-center"
      style={{
        background:
          "linear-gradient(180deg, rgba(22,24,33,0.75) 0%, rgba(13,14,19,0.85) 100%)",
        borderColor: "rgba(201, 167, 85, 0.35)",
      }}
      data-testid={testid}
    >
      <h3
        className="font-serif text-[22px] leading-[1.2]"
        style={{
          color: "var(--gold)",
          fontFamily: "'Playfair Display', Georgia, serif",
          margin: 0,
          letterSpacing: "-0.005em",
        }}
        data-testid={`${testid}-title`}
      >
        Which philosopher thinks like you?
      </h3>
      <p
        className="mt-3 text-[13px]"
        style={{ color: "var(--muted)", letterSpacing: "0.04em" }}
        data-testid={`${testid}-tagline`}
      >
        20 questions · 6 traits · 3 minutes · free, no signup
      </p>
      <Link
        to="/"
        className="btn-primary mt-6 inline-block"
        style={{ marginTop: 24 }}
        data-testid={`${testid}-button`}
      >
        Take the free test
      </Link>
    </aside>
  );
}
